import { useDispatch } from 'react-redux';
import FJObjectEraseLeftContainer from './FJObjectEraseLeft/container/FJObjectEraseLeftContainer.jsx';
import FJObjectEraseRightContainer from './FJObjectEraseRight/container/FJObjectEraseRightContainer.jsx';
import FJActionObjectErase from '../../redux/action/FJActionObjectErase.js';
import { useEffect } from 'react';

function FJObjectErase() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(FJActionObjectErase.initObjectEraseProjectAction());
    }, [dispatch]);

    return (
        <>
            <FJObjectEraseLeftContainer />
            <FJObjectEraseRightContainer />
        </>
    );
}

export default FJObjectErase;
